<template>
  <div>
    <div class="w100" v-if="siftData.length > 0">
      <SiftComp ref="sift" :sift-data="siftData" :loading="loading" @click-search="fetchData" />
    </div>

    <div class="w100 pb20 cl-f">
      <div class="fr pr10">
        <el-button v-if="appData" @click="$emit('click-collect', appData.isCollect)" :loading="collecting">
          <i class="yellow" :class="appData.isCollect ? 'el-icon-star-on' : 'el-icon-star-off'"></i>
          {{ appData.isCollect ? '取消收藏' : '点击收藏' }}
        </el-button>
        <el-button v-if="siftData.length > 0" type="primary" :loading="loading" @click="fetchData()">查询</el-button>
      </div>
    </div>

    <section v-if="error == 0 && labelData.length > 0" v-loading="loading">
      <el-table class="w100 tx-c my-table" :data="listData" stripe border height="460">
        <el-table-column v-for="(item, index) in labelData" :key="index" :label="item.label" v-show="item.key != 'courseID' && item.key != 'teachClassID'" resizable align="center">
          <template slot-scope="scope">
            <span v-if="item.key != 'operation'">{{ scope.row[item.key] }}</span>
            <span class="blue cu-p" v-else @click="showStuScoreList(scope.row)">查看</span>
          </template>
        </el-table-column>
      </el-table>

      <div class="w100 mt20 tx-r">
        <el-pagination @size-change="changeSize" @current-change="changePage" :current-page="page" :page-sizes="[30, 50, 100]" :page-size="size" layout="total, sizes, prev, pager, next, jumper" background :total="total"></el-pagination>
      </div>
    </section>

    <el-dialog width="1200px" :visible.sync="isShow" :close-on-click-modal="false">
      <el-table class="w100" :data="stuScoreList" stripe border max-height="600">
        <el-table-column prop="stuId" label="学号" align="center" width="120"></el-table-column>
        <el-table-column prop="stuName" label="姓名" align="center"></el-table-column>
        <el-table-column prop="sex" label="性别" align="center" width="55"></el-table-column>
        <el-table-column prop="college" label="学院" align="center" width="180"></el-table-column>
        <el-table-column prop="major" label="专业" align="center"></el-table-column>
        <el-table-column prop="grade" label="年级" align="center"></el-table-column>
        <el-table-column prop="classes" label="班级" align="center"></el-table-column>
        <el-table-column prop="credit" label="学分" align="center"></el-table-column>
        <el-table-column prop="score" label="成绩" align="center"></el-table-column>
        <el-table-column prop="examNature" label="考试性质" align="center"></el-table-column>
        <el-table-column prop="isdegreeCourse" label="是否学位课程" align="center"></el-table-column>
        <el-table-column prop="point" label="绩点" align="center"></el-table-column>
        <el-table-column prop="courseNature" label="课程性质" align="center" width="120"></el-table-column>
        <el-table-column prop="scoreRemark" label="成绩备注" align="center"></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import SiftComp from "@/components/CompSift/SiftComp";

export default {
  name: "StuScore",
  components: {
    SiftComp
  },
  props: ["url", "app-data", "collecting"],
  data() {
    return {

      loading: false,
      error: "",

      siftData: [],
      labelData: [],

      listData: [],
      page: 1,
      size: 30,
      total: 0,

      isShow: false,
      stuScoreList: []
    };
  },
  computed: {
    ...mapState(["userData"])
  },
  created() {},
  mounted() {
    this.fetchSiftData();
  },
  methods: {
    showStuScoreList(obj) {
      this.loading = true;

      this.$http
        .post(
          "stuScore/queryByTea",
          this.$qs.stringify({
            courseID: obj.courseID,
            teachClassID: obj.teachClassID,
            pageNum: 1,
            pageSize: 9999
          })
        )
        .then(({ data }) => {
          if (data.resCode == 0 && data.resStatus == 0) {
            // console.log(data.resData);
            this.stuScoreList = data.resData.list;
            this.$nextTick(() => {
              this.isShow = true;
            });
          } else {
            this.$notify({
              title: "错误",
              message: data.resMsg,
              type: "error",
              offset: 60
            });
          }
          this.loading = false;
        })
        .catch(() => {
          this.error = 404;
          this.$notify({
            title: "错误",
            message: "网络请求错误，请检查网络",
            type: "error",
            offset: 60
          });

          this.loading = false;
        });
    },
    fetchSiftData() {
      this.loading = true;

      this.$http
        .post(
          this.$route.query.interfaceUrl + `/getTitleData`,
          this.$qs.stringify({
            userId: this.userData.userId,
            id: this.$route.query.id
          })
        )
        .then(({ data }) => {
          if (data.resCode == 0 && data.resStatus == 0) {
            // console.log(data.resData);
            if (data.resData.siftData) {
              this.siftData = data.resData.siftData;
            }
            if (data.resData.labelData) {
              this.labelData = data.resData.labelData;
            }
            this.$nextTick(() => {
              this.fetchData();
            });
          } else {
            this.$notify({
              title: "错误",
              message: data.resMsg,
              type: "error",
              offset: 60
            });
          }
          this.loading = false;
        })
        .catch(() => {
          this.error = 404;
          this.$notify({
            title: "错误",
            message: "网络请求错误，请检查网络",
            type: "error",
            offset: 60
          });

          this.loading = false;
        });
    },
    fetchData() {
      let obj = {};
      if (this.siftData.length > 0) {
        obj = this.$refs.sift.clickSearchBtn();
      }

      obj.userId = this.userData.userId;
      obj.pageNum = this.page;
      obj.pageSize = this.size;

      this.loading = true;
      this.$http
        .post(
          this.$route.query.interfaceUrl + `/query`,
          this.$qs.stringify(obj)
        )
        .then(({ data }) => {
          // console.log(data);
          if (data.resCode == 0 && data.resStatus == 0) {
            this.total = data.resData.total;
            this.listData = data.resData.list;
          } else {
            this.$notify({
              title: "错误",
              message: data.resMsg,
              type: "error",
              offset: 60
            });
          }
          this.loading = false;
        })
        .catch(() => {
          this.$notify({
            title: "错误",
            message: "网络请求错误，请检查网络",
            type: "error",
            offset: 60
          });
          // this.error = 404;
          this.loading = false;
        });
    },
    changeSize(value) {
      this.size = value;
      this.fetchData();
    },
    changePage(value) {
      this.page = value;
      this.fetchData();
    }
  }
};
</script>

<style scoped>
</style>
